export const SeoData = {

    'default': {
        title: 'Box8 - Food delivery | Order food online in Mumbai, Delhi NCR, Bangalore, Hyderabad, Pune, Chennai & Kolkata',
        description: "Order delicious meals online from India's Largest Desi Meals Brand. 2 Cr+ meals served across 300+ stores in Mumbai, Delhi NCR, Bangalore, Hyderabad, Pune, Chennai & Kolkata"
    },

    '/menu': {
        description: 'Mouth-watering Dal Makhni, Rajma, Paneer Tikka, Moong Dal ka Halwa & more! All-In-1-Meals, Curries, Parathas, Desi Boxes, Starters, Desserts & more.'
    },

    '/offers': {
        description: '₹200 Off on first 3 orders. Use Code: NEW only on BOX8 App/Web'
    },

    '/membership' : {
        title: 'Join EatClub - Save 30% Everytime',
        description: 'Get EatClub membership & Save 30% Everytime. NO T&C. ZERO Delivery/ Packaging Fees.'
    },

    '/refer': {
        description: 'Earn ₹500 Credits per referral. Credits = Real Cash! Keep earning free meals; refer unlimited friends!',
    },

    '/about': {
        description: "India's Pioneers of Desi Meals. From Paneer Makhni to Butter Chicken to Gulab Jamun, we have all your delicious Desi Meals."
    }
};